import { render, staticRenderFns } from "./order_refund.vue?vue&type=template&id=10b06eca&scoped=true"
import script from "./order_refund.vue?vue&type=script&lang=js"
export * from "./order_refund.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b06eca",
  null
  
)

export default component.exports